import PropTypes from 'prop-types';

export const Number = (props) => {
  let value;
  if (typeof props === 'number') {
    value = props;
  } else if (typeof props.cell.value === 'number') {
    value = props.cell.value;
  } else {
    // eslint-disable-next-line no-console
    console.error('Value provided for `Number` cell component is not accepted');
  }

  return value;
};

Number.propTypes = {
  cell: PropTypes.object,
};
